<template>
  <div class="col-xs-12 col-sm-6 default-list-contain-sty">
    <div class="order-title-area-sty">
      <div class="order-main-title-sty">
        <h3>加入服務員行列</h3>
      </div>
    </div>
    <div class="order-contain">
      <div class="order-sub-title-sty">
        <h5>請填寫個人基本資料</h5>
      </div>
      <div class="form-group">
        <label for="name">姓名</label>
        <input type="text" class="form-control" id="name" name="name" value="" maxlength="100" v-model="name">
        <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
        <label for="nick_name">綽號</label>
        <input type="text" class="form-control" id="nick_name" name="nick_name" value="" maxlength="100" v-model="nick_name">
        <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
          <label for="phone">手機號碼</label>
          <input type="text" class="form-control" id="phone" name="phone" value="" maxlength="10" placeholder="手機 / 市話" v-model="phone">
          <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
          <div>性別</div>
          <div class="order-radio-area-sty row">
            <div class="col-sm-4" v-for="(staff_gender, index) in staff_genders" :key="index">
              <input type="radio" :id="`staff_gender_${ staff_gender.id }`" :value="staff_gender.id" v-model="gender">
              <label :for="`staff_gender_${ staff_gender.id }`">{{ staff_gender.label }}</label>
            </div>
          </div>
      </div>
      <div class="form-group">
        <label for="iden">身分證字號</label>
        <input type="text" class="form-control" id="iden" name="iden" value="" maxlength="10" v-model="iden">
        <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
        <label for="birth">生日</label>
        <input type="date" class="form-control" id="birth" name="birth" :min="`${getOrderBirthDate()}`" :max="`${getYoungerBirthDate()}`" v-model="birth">
      </div>
      <div class="form-group">
      <label for="city">縣市 (選項以外區域請在地址欄位填寫完整地址)</label>
      <select class="form-control" id="countries" name="countries" data-orig-value="" v-model="country_id">
        <option selected="selected" disabled="">請選擇</option>
        <option v-for="(country, index) in countriesArray" :key="index" :value="country.id">{{ country.name }}</option>
      </select>
      <div id="contries_error_area" class="help-block with-errors"></div>
    </div>
    <div class="form-group">
      <label for="district">鄉鎮區</label>
          <select class="form-control" id="district" name="district" data-orig-value="" v-model="city_id">
            <option selected="selected" disabled="">請選擇</option>
            <option v-for="(city, index) in this.citiesArray" :key="index" :value="city.id">{{ city.label }}</option>
          </select>
          <div class="help-block with-errors"></div>
    </div>
      <div class="form-group">
        <label for="address">地址</label>
        <input type="text" class="form-control" id="address" name="address" value="" maxlength="100" placeholder="現居地址" v-model="address">
        <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
          <label for="emegency_contact">緊急聯絡人</label>
          <input type="text" class="form-control" id="emegency_contact" name="emegency_contact" value="" maxlength="100" v-model="emegency_contact">
          <div class="help-block with-errors"></div>
      </div>
      <div class="form-group">
          <label for="emegency_phone">手機號碼</label>
          <input type="text" class="form-control" id="emegency_phone" name="emegency_phone" value="" maxlength="10" placeholder="手機 / 市話" v-model="emegency_phone">
          <div class="help-block with-errors"></div>
      </div>
      <hr>
      <div class="order-footer-contain text-right">
        <b-button
            class="text-white"
            variant="info"
            size="lg"
            @click="submitStaffForm"
            :disabled="
              (name && phone && iden && emegency_contact && emegency_phone && address && country_id && city_id)? false : true"
            >送出
        </b-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'CreateStaff',
  data () {
    return {
      staff_genders: [{ id: 1, label: '女' }, { id: 0, label: '男' }],
      name: '',
      nick_name: '',
      phone: '',
      gender: '',
      birth: '',
      iden: '',
      country_id: '',
      city_id: '',
      address: '',
      emegency_contact: '',
      emegency_phone: '',
      countriesArray: [],
      citiesArray: [],
      insurance: false
    }
  },
  created () {
    this.getCountryInfo()
  },
  watch: {
    country_id () {
      const self = this
      var currentCountry
      currentCountry = this.countriesArray.find((country) => {
        var isTarget = false
        if (country.id === self.country_id) {
          isTarget = true
        }
        return isTarget
      })
      this.citiesArray = currentCountry.cities
      this.city_id = ''
    }
  },
  methods: {
    getCountryInfo () {
      const self = this
      const finalUrl = this.$apiDoc.staffUrl + this.$apiDoc.apiActionNew
      this.$api.get(finalUrl, {}).then((resp) => {
        if (resp.result && resp.data && resp.data.countries) {
          self.countriesArray = resp.data.countries
        } else {
          self.countriesArray = this.$toolDoc.getDefaultStaffCountry()
        }
      }).catch((errorInfo) => {
        console.log('errorInfo:', errorInfo)
        self.countriesArray = this.$toolDoc.getDefaultStaffCountry()
      })
    },
    getOrderBirthDate () {
      var dateObj = new Date()
      return (dateObj.getFullYear() - 80) + '-' + (dateObj.getMonth() + 2) + '-' + dateObj.getDate()
    },
    getYoungerBirthDate () {
      var dateObj = new Date()
      return (dateObj.getFullYear() - 18) + '-' + (dateObj.getMonth() + 2) + '-' + dateObj.getDate()
    },
    submitStaffForm () {
      const userId = this.$store.getters.getUserId
      const postUrl = this.$apiDoc.staffUrl + userId
      var apiOptions = {
        name: this.name,
        nick_name: this.nick_name,
        phone: this.phone,
        gender: this.gender,
        birth: new Date(this.birth).toISOString(),
        iden: this.iden,
        country_id: this.country_id,
        city_id: this.city_id,
        address: this.address,
        emegency_contact: this.emegency_contact,
        emegency_phone: this.emegency_phone,
        insurance: this.insurance
      }
      console.log('apiOptions', apiOptions)
      if (userId) {
        this.$api.post(postUrl, apiOptions).then((resp) => {
          alert('成功申請加入，等待驗證')
          this.$liff.closeWindow()
        }).catch((errorInfo) => {
          console.log('errorInfo:', errorInfo)
          alert('發生錯誤')
          this.$liff.closeWindow()
        })
      }
    }
  }
}
</script>
